import React, { useEffect, useState } from 'react';
import api from '~/services/api';
import { Label, Input, Select, TextArea } from '~/componentes/CustomForm';
import CheckBox from "~/componentes/CustomForm/Check/styles/CheckBox";

import { Container } from './styles';
import CustomScrollBar from '~/componentes/CustomScrollBar';
import { Materialize } from '~/styles/materializeGrid';
import { SLModalFooter } from '~/pages/Sistema/componentes/SistemaList';
import ShowConfirmacao from '~/utils/ShowConfirmacao';
import Acoordion from '~/componentes/Acoordion';
import Button from '~/componentes/Button';
import IconLixeira from '~/assets/icones/IconLixeira.svg';
import AtividadesList from './AtividadesList';

function CreateContent({ mountedData }) {
  const [atividades, setAtividades] = useState([]);

  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    return ShowConfirmacao(
      async () => {
        let thisData = {
          id: mountedData?.id,
          atividades,
        };

        let response = await api.put("/signed/empresa/gestorprojeto/ordemservicomod2", thisData);
        if (response?.status === 200) {
          closeReload && closeReload();
        }

        return response;
      },
      {
        errorModal: {
          defaultMessage: `Ocorreu um erro ao cadastrar essa Ordem de Serviço, por favor, tente novamente mais tarde.`,
        },
        message: `Tem certeza que deseja cadastrar essa Ordem de Serviço?`,
        successModal: `Ordem de Serviço cadastrada com sucesso!`,
      },
    );
  }

  return (
    <Container onSubmit={handleSubmit} defaultScroll={true}>
      <Materialize className="materialize">
        <div className="row header">
          <p className="h-descricao">
            Preencha as informações corretamente, e se atente ao (*) pois são
            campos obrigatórios
          </p>
        </div>
        <div className="row">
          <div className="col s12 m12 l12">
            <AtividadesList setter={setAtividades} defaultData={mountedData?.itens || []} />
          </div>
        </div>
      </Materialize>
    </Container>
  );
}

export default CreateContent;
